
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[category]/[subcategory]/[id]",
      function () {
        return require("private-next-pages/[category]/[subcategory]/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[category]/[subcategory]/[id]"])
      });
    }
  